export default function SmsCounter() { }

SmsCounter.gsm7bitRegExp = new RegExp("^[@£$¥èéùìòÇ\\nØø\\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ\\s!\\\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà" + "\\^{}\\\\\\[~\\]|€]*$");

SmsCounter.GSM_7BIT = 'GSM_7BIT';

SmsCounter.UTF16 = 'UTF16';

SmsCounter.messageLength = {
    GSM_7BIT: 160,
    UTF16: 70
};

SmsCounter.multiMessageLength = {
    GSM_7BIT: 153,
    UTF16: 67
};

SmsCounter.count = function (text) {
    var count, encoding, length, sms_message_count, per_message, sms_chars_remaining;
    encoding = this.detectEncoding(text);
    length = text.length;
    per_message = this.messageLength[encoding];
    if (length > per_message) {
        per_message = this.multiMessageLength[encoding];
    }

    sms_message_count = Math.ceil(length / per_message);
    sms_chars_remaining = (per_message * sms_message_count) - length;
    if (sms_chars_remaining === 0 && sms_message_count === 0) {
        sms_chars_remaining = per_message;
    }

    var percent = parseInt((per_message - sms_chars_remaining) / per_message * 100);

    return count = {
        percent: percent,
        encoding: encoding,
        length: length,
        per_message: per_message,
        sms_chars_remaining: sms_chars_remaining,
        sms_message_count: sms_message_count
    };
};

SmsCounter.detectEncoding = function (text) {
    if (this.gsm7bitRegExp.test(text)) {
        return this.GSM_7BIT;
    }
    return this.UTF16;
};
